import React from 'react';
import {Plus} from "assets/icons";
import Button from "components/button";
import Divider from "components/divider/divider";
import useModal from "components/modal/useModal";
import usefetchdata from "hooks/usefetchdata";
import UseContext from "hooks/useContext";
import CardProfile from "components/card/cardProfile/cardProfile";
import LicenceRow from "components/licences/LicenceRow";
import useLicenceTexts from "components/licences/useLicenceTexts";
import useTitle from "../../../hooks/TitleManager";

const Licences = () => {
    useTitle({ title: "Profil - Mes justificatifs - Permis" });
    const {toggle} = useModal()
    const {tempWorkerData} = usefetchdata()
    const {setObjID, setObjType, setLicenceModalPreset} = UseContext()
    const {translate} = useLicenceTexts()
    const licences = Array.isArray(tempWorkerData?.licences) ? tempWorkerData.licences : []

    const openAddLicence = () => {
        setLicenceModalPreset(null)
        toggle('j_c_licence')
    }

    const openLicenceDetail = (entry) => {
        setObjID(entry._id)
        toggle('j_g_licence')
    }

    const confirmLicenceDeletion = (entry) => {
        setObjID(entry._id)
        setObjType('licence')
        toggle('j_d_delete')
    }

    return (
        <CardProfile>
            <div className="ft-b text-gray-900">
                {translate('list.title')}
            </div>
            <div className={'my-5'}>
                <Divider w={100}/>
            </div>
            {licences.length ? (
                <div className="flex flex-col">
                    {licences.map(entry =>
                        <LicenceRow
                            key={entry._id}
                            entry={entry}
                            onOpen={openLicenceDetail}
                            onDelete={confirmLicenceDeletion}
                        />
                    )}
                </div>
            ) : (
                <p className="ft-sm text-gray-500">{translate('list.empty')}</p>
            )}
            <div className="mt-6">
                <Button size={'FULL'} color={'PRIMARY'} onClick={openAddLicence}>
                    <Plus wh={14} color={'#FFFFFF'}/>
                    {translate('list.add_button')}
                </Button>
            </div>
        </CardProfile>
    );
};

export default Licences;
